import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class NotificationEndpointService {
  readonly #service = inject(ServicesService);

  getNotifications() {
    return this.#service.edition('notifications');
  }

  getNotificationsForMethod(methodSlug: string) {
    return this.#service.edition(`method/${methodSlug}/notifications`);
  }

  getNotificationSeen(notificationId: number) {
    return this.#service.edition(`notifications/${notificationId}/seen`);
  }

  getNotificationAllSeen(methodSlug: string, untilNotificationId: number) {
    return this.#service.edition(
      `method/${methodSlug}/notifications/${untilNotificationId}/seen`,
    );
  }

  getnotificationDelete(notificationId: number) {
    return this.#service.edition(`notifications/${notificationId}`);
  }
}
